// extracted by mini-css-extract-plugin
export default {"background":"FVsnf","language-de":"vSg1L","language-en":"i1TV0","language-es":"US9Pg","language-fr":"o7l1t","language-it":"KOZmC","language-nl":"DZv0B"};